import { InformationIcon } from 'icons/outline';
import { ActionButtonTooltip } from 'features/ApplicantsTrackingSystem/ApplicantsTable/ApplicantsTableRow/ActionButtons/ActionButtonTooltip';

type MessageOptionTooltipProps = {
  optionText: string;
  tooltipText: string;
  tooltipId: string;
};
export const MessageOptionTooltip = ({
  optionText,
  tooltipText,
  tooltipId,
}: MessageOptionTooltipProps) => {
  return (
    <>
      {optionText}
      <ActionButtonTooltip
        id={tooltipId}
        dataTip={<InformationIcon className="w-4 h-4" />}
        className="font-medium !w-full !bg-neutral-full-white"
        alwaysShow={false}
        background="dark"
      >
        {tooltipText}
      </ActionButtonTooltip>
    </>
  );
};

MessageOptionTooltip.displayName = 'MessageOptionTooltip';
